import { useContext } from "preact/hooks";
import { ValuesStoreContext } from "store/Values";

export const useValuesStore = () => useContext(ValuesStoreContext);
